import { ReactElement } from 'react';
import { useForm } from 'react-hook-form';

type RadioProps = {
  id: string;
  checked: boolean;
  label: string;
  note?: string;
  value: string;
  onValueChange: (check: string) => void;
};

/**
 * Radio control component.
 * @param props - Properties of Radio control component.
 * @returns - React component for Radio control.
 */
export default function CustomRadio(props: RadioProps): ReactElement {
  const { id, checked, label, note, value, onValueChange } = props;
  const { register } = useForm();
  // const [btnvalue,setBtnvalue]= useState('');
  return (
    <label htmlFor={id} className="flex items-center text-gray-300 text-sm font-medium">
      <input
        type="radio"
        value={value}
        id={id}
        checked={checked}
        // eslint-disable-next-line
        {...register(id, { onChange: onValueChange })}
        className="form-radio h-4 w-4 mr-2 text-primary-600"
      />
      {label}
      {note && <span className="text-gray-500 font-medium text-base ml-4">({note})</span>}
    </label>
  );
}
